import { render, staticRenderFns } from "./OwnReport.vue?vue&type=template&id=24652def"
import script from "./OwnReport.vue?vue&type=script&lang=js"
export * from "./OwnReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports